import { Content } from "@/interfaces/content";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let user = localStorage.user ? JSON.parse(localStorage.user) : null;
let jwt = localStorage.jwt ? localStorage.jwt : null;

export default new Vuex.Store({
  state: {
    feed: null,
    purchases: null,
    showChargeModal: false,
    contents: {},
    contentsByCategory: {},
    user: user,
    jwt: jwt,
    cannotLoadPage: false,
    isLoading: true,
    videoCategories: {}
  },
  mutations: {
    /* A fit-them-all commit */
    basic(state: any, payload: any) {
      state[payload.key] = payload.value;
    },
    set(state: any, options: any) {
      state.views[options.view][options.field] = options.value;
    },
    startLoading(state: any) {
      state.isLoading = true;
    },
    stopLoading(state: any) {
      state.isLoading = false;
    },
    setUser(state: any, user: any) {
      if (!state.user) {
        state.user = user;
      } else {
        const auth0 = state.user.auth0;
        state.user = user;
        state.user.auth0 = auth0;
      }
      localStorage.user = JSON.stringify(state.user);
    },
    setAuth0User(state: any, user: any) {
      if (!state.user) {
        state.user = {
          auth0: user
        };
      } else {
        state.user.auth0 = user;
      }
      localStorage.user = JSON.stringify(state.user);
    },
    logout(state: any, setIsLoading: boolean = false) {
      state.user = null;
      state.jwt = null;
      localStorage.removeItem("user");
      localStorage.removeItem("jwt");
      state.isLoading = setIsLoading;
    },
    setContent(state: any, content: Content) {
      state.contents[content.content_id] = content;
    },
    setContentsByCategory(state: any, payload: any) {
      state.contentsByCategory[payload.category] = payload.contents;
    }
  },
  actions: {},
  getters: {},
  modules: {}
});
